import React from 'react';
import propTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { useUiField } from '../hooks';
import { UiField } from './UiField';
import { Input } from 'src/ui/mui-ui-kit';

export function UiInput({ mask = null, ...props }) {
  const [uiFieldProps, inputProps] = useUiField(props);
  const InputComponent = mask ? MaskedInput : Input;

  return (
    <UiField {...uiFieldProps}>
      <InputComponent {...inputProps} mask={mask} />
    </UiField>
  );
}



// eslint-disable-next-line react/require-default-props
UiInput.propTypes = {
  mask: propTypes.oneOfType([propTypes.array, propTypes.func]),
};
